import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileArrowLeftIn: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="file-arrow-left-in, document-arrow-left-in, incoming"><path d="M14.75 21.25H19.25V9.25L12.75 2.75H4.75V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 3.25439V9.24982H18.7501" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M3.75 19H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.25 16L11.25 19L8.25 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFileArrowLeftIn;
